<template>
    <div class="panel">
        <div class="panel-heading clearfix">
            <a @click="up()"><i class="icon-up icon"></i></a>
            <a @click="down()"><i class="icon-down icon"></i></a>
            <button @click="edit" class="btn pull-right btn-primary">EDIT</button>
            <span class="proposal-inv-title" v-html="block.title"></span>
            <i v-if="block.page_break" class="icon icon-pdf"></i>
        </div>
        <div class="panel-body panel-block" v-html="block.content"></div>
    </div>
</template>

<script>
    import SortableBlock from "./SortableBlock";
    export default {
        name: "htmlBlock",
        mixins: [ SortableBlock ],
        props:{
            input: { default: '' },
        },
        components: {},
        data() {
            return {
                block: {}
            }
        },
        watch: {
            input: function(newVal, oldVal) { // watch it
                this.block = this.input;
            }
        },
        created() {
            this.$eventHub.$on('updateHtmlBlock', this.updateHtmlBlock);
            this.block = this.input;
        },
        methods: {
            updateHtml() {
            },
            edit() {
                this.$eventHub.$emit('closeRightPanel', () => {
                    this.$nextTick(() => {
                        this.$root.viewLoader('/api/proposal/' + this.block.public_id, false, false);
                    });
                });
            },
            updateHtmlBlock(block) {
                if (block.public_id !== this.block.public_id) return;
                this.block = Object.assign({}, block);
            }
        },

        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
            this.$eventHub.$off('updateHtmlBlock', this.updateHtmlBlock);
        },

    }
</script>

<style scoped>
    .panel-body.panel-block {
        padding: 0 15px !important;
    }
</style>